/* ==========================================================================
   WAYPOINT — haptic ticks. Thin wrapper over navigator.vibrate, no-op where
   unsupported (desktop browsers, iOS Safari without permission, etc).
   ========================================================================== */

function vibrate(pattern: number | number[]): void {
  try {
    navigator.vibrate?.(pattern);
  } catch {
    // Some browsers throw on vibrate() calls outside a user gesture; ignore.
  }
}

/** Light tick — sheet snap, drag-end, PIN digit press. */
export function tick(): void {
  vibrate(8);
}

/** Slightly stronger tick — booking success, tool_result landed. */
export function success(): void {
  vibrate([8, 40, 12]);
}

/** Sharp double-buzz — wrong PIN / hard validation error. */
export function error(): void {
  vibrate([16, 60, 16]);
}
